import { useState, useEffect } from 'react';
import { getAppViewport } from '../utils/appViewport';

function getWindowDimensions() {
  const viewport = getAppViewport();
  return {
    // Keep desktop interaction breakpoints tied to the browser, even when the
    // app's content is displayed in a narrower canvas.
    width: window.innerWidth,
    height: viewport.height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

  useEffect(() => {
    function handleResize() {
      const next = getWindowDimensions();
      setWindowDimensions(current => current.width === next.width
        && current.height === next.height ? current : next);
    }

    // The frame may not have mounted when the hook first renders.
    handleResize();
    const viewport = document.getElementById('appViewport');
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(handleResize) : null;
    if (viewport) observer?.observe(viewport);
    window.addEventListener('resize', handleResize);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowDimensions;
}
